<template>
    <div class="bg-a-egg-f5ebdc min-h-screen">
        <TopBarLogo :showLangSwitchBtn="showLangSwitchBtn"></TopBarLogo>
        <div class="page-padding-top">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import TopBarLogo from '../TopBar/TopBarLogo.vue'

export default {
    components: {
        TopBarLogo,
    },
    props: {
        showLangSwitchBtn: { type: Boolean, default: true },
    },
}
</script>
<style lang="scss" scoped>
    @import '@/style/base/base.scss';
    .page-padding-top {
        padding-top: $topbar-height;
    }
</style>
